<template>
  <div class="app-email-confirmation-wrapper">
    <div v-if="urlParametersValid === false">
      <slot name="invalidLink">
        Der aufgerufene Link ist ungültig. Bitte überprüfen Sie, ob Sie den Adresse vollständig kopiert haben.
      </slot>
    </div>
    <ConfirmBirthdate v-else-if="changeView === 'confirmBirthdate'" >
      <template #txtBefore><slot name="confirmBirthdateTxtBefore"></slot></template>
      <template #lblBirthdate><slot name="confirmBirthdateLblBirthdate"></slot></template>
      <template #errorMessageBirthdate><slot name="confirmBirthdateErrorMessageBirthdate"></slot></template>
      <template #btnNext><slot name="confirmBirthdateBtnNext"></slot></template>
    </ConfirmBirthdate>
    <ConfirmEmailSucceeded v-if="changeView === 'success'" :back-button-href="backButtonHref">
      <template #confirmEmailTxtBefore><slot name="successConfirmEmailTxtBefore"></slot></template>
      <template #confirmEmailBtnSuccessBack><slot name="successConfirmEmailBtnSuccessBack"></slot></template>
    </ConfirmEmailSucceeded>
  </div>
</template>

<script>
import ConfirmBirthdate from './Birthdate.vue'
import ConfirmEmailSucceeded from './Success.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'EmailConfirmationWrapper',
  props: {
    backButtonHref: {
      Type: String,
      default: '#'
    }
  },
  mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    this.captureEmailConfirmationParameter({ token: urlParameters.get('token'), solicitorId: urlParameters.get('solicitorID') })
  },
  mixins: [
    transaction('confirmEmailVerification')
  ],
  methods: {
    ...mapMutations('emailConfirmation', [
      'captureEmailConfirmationParameter'
    ])
  },
  computed: {
    ...mapGetters('emailConfirmation', [
      'getView',
      'urlParametersValid'
    ]),
    changeView () {
      return this.getView
    }
  },
  components: { ConfirmEmailSucceeded, ConfirmBirthdate }
}
</script>
